import { render, staticRenderFns } from "./CreateFromImportBaremetal.vue?vue&type=template&id=16ff6e4a"
import script from "./CreateFromImportBaremetal.vue?vue&type=script&lang=js"
export * from "./CreateFromImportBaremetal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports